export default {
  page_url: function(val) {
    val = val.trim().replace(/ /g, "-")
    val = val.replace(/[^a-zA-Z0-9_-]/g, "")
    val = val.replace(/-+/g, "-")
    val = val.toLowerCase()

    return val
  }
}
